import {openInappbrowser} from '@zzng/common/scheme/inappbrowser';
import {TrackInterface} from '@zzng/common/utils/tiara';

import {TIARA_ACTION} from '@/shared/constants/tiara';
import {KAKAO_CORP_URL, PROPOSITION_URL, TERMS_URL} from '@/shared/constants/url';

type Props = {
  trackEvent: (tiara: TrackInterface) => void;
};

// Deprecated 예정
const DesktopFooter = ({trackEvent}: Props) => {
  return (
    <div className="doc-footer" role="contentinfo">
      <h2 className="screen_out">서비스 이용정보</h2>
      <div className="inner_g">
        <div className="menu_footer">
          <button
            type="button"
            className="btn_menu"
            onClick={() => {
              trackEvent({action: TIARA_ACTION.TERMS_CLICK});
              openInappbrowser(TERMS_URL);
            }}
          >
            이용약관
          </button>
          <button
            type="button"
            className="btn_menu"
            onClick={() => {
              trackEvent({action: TIARA_ACTION.PARTNER_CLICK});
              openInappbrowser(PROPOSITION_URL);
            }}
          >
            제휴안내
          </button>
        </div>
        <small className="txt_copy">
          <a
            className="link_copy"
            href="#none"
            onClick={(e) => {
              e.preventDefault();
              trackEvent({action: TIARA_ACTION.KAKAO_CLICK});
              openInappbrowser(KAKAO_CORP_URL);
            }}
          >
            (주) 카카오
          </a>
        </small>
        <div className="info_footer">
          <dl className="list_info">
            <dt>대표</dt>
            <dd>정신아</dd>
            <dt>사업자등록번호</dt>
            <dd>120-81-47521</dd>
          </dl>
          <dl className="list_info">
            <dt>통신판매업신고번호</dt>
            <dd>제2015-제주아라-0032호</dd>
          </dl>
          <dl className="list_info">
            <dt>주소</dt>
            <dd>제주특별자치도 제주시 첨단로 242(영평동)</dd>
          </dl>
          <dl className="list_info">
            <dt>호스팅사업자</dt>
            <dd>(주) 카카오</dd>
            <dt>고객센터</dt>
            <dd>1577-3754</dd>
          </dl>
          <dl className="list_info">
            <dt>메일</dt>
            <dd>help.notice@kakaocorp.com</dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default DesktopFooter;
